// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import JyMultipleUpload from './components/jy-multiple-upload/index.js'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/index.less'
import '../src/style/font_4357490_v1twkese08/iconfont.css'

import * as filters from './filters'
// 注册自定义的插件
import greatsoft from './plugins'

const components = [JyMultipleUpload]

// 全局引入
components.forEach(component => {
  component.install(Vue)
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(greatsoft)

Vue.directive('loadmore', {
  bind (el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js